import React from "react";

const total = 1248;
const segments = [
  { label: "New visitors", value: 68, count: 848, color: "var(--hostor-primary)" },
  { label: "Returning visitors", value: 32, count: 400, color: "#8b8ff2" },
];

const R = 70;
const CIRCUMFERENCE = 2 * Math.PI * R;

export default function VisitorsDonut() {
  let offset = 0;

  return (
    <section className="dash-card an-donut-card">
      <div className="dash-card-header">
        <h2 className="dash-card-title">New vs returning visitors</h2>
      </div>

      <div className="an-donut-row">
        <div className="an-donut-wrap">
          <svg viewBox="0 0 180 180" className="an-donut-svg" role="img" aria-label="New versus returning visitors, donut chart">
            <circle cx="90" cy="90" r={R} fill="none" stroke="var(--hostor-bg)" strokeWidth="22" />
            {segments.map((seg) => {
              const dash = (seg.value / 100) * CIRCUMFERENCE;
              const circle = (
                <circle
                  key={seg.label}
                  cx="90"
                  cy="90"
                  r={R}
                  fill="none"
                  stroke={seg.color}
                  strokeWidth="22"
                  strokeDasharray={`${dash} ${CIRCUMFERENCE - dash}`}
                  strokeDashoffset={-offset}
                  transform="rotate(-90 90 90)"
                />
              );
              offset += dash;
              return circle;
            })}
          </svg>
          <div className="an-donut-center">
            <strong>{total.toLocaleString()}</strong>
            <span>Total</span>
          </div>
        </div>

        <ul className="an-donut-legend">
          {segments.map((seg) => (
            <li key={seg.label}>
              <span className="an-donut-dot" style={{ background: seg.color }} />
              <span className="an-donut-legend-text">
                <span>{seg.label}</span>
                <strong>
                  {seg.value}% ({seg.count})
                </strong>
              </span>
            </li>
          ))}
        </ul>
      </div>

      <div className="an-insight-note">
        <span className="an-insight-note-icon">
          <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.4">
            <path d="M4 16l6-6 4 4 6-7" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M15 7h5v5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </span>
        <span>
          <strong>New visitors increased 12.5%</strong>
          <br />
          compared to the previous 7 days.
        </span>
      </div>
    </section>
  );
}
